import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=2e0d307a&"
import script from "./Call.vue?vue&type=script&lang=ts&"
export * from "./Call.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports